import register from '../../../../global/js/registry';
export default register('m-nav-bar', () => import(/* webpackMode: "lazy" */ './m-nav-bar.controller'));
